import { Timestamps } from '@/api/global/types/timestamps'
// nosemgrep: api-layer-import-restrictions
import { EntityRole } from '@/legacy/types/entities/entities'
// nosemgrep: api-layer-import-restrictions
import { StatusReasonMetadata } from '@/legacy/types/pathways/common'
// nosemgrep: api-layer-import-restrictions
import { StatusReason } from '@/legacy/types/pathways/pathways'
// nosemgrep: api-layer-import-restrictions
import { Reattempt } from '@/legacy/types/pathways/reattempts'
// nosemgrep: api-layer-import-restrictions
import { SubtaskPriority, QueueStyle } from '@/legacy/types/pathways/subtasks'
// nosemgrep: api-layer-import-restrictions
import { Patient } from '@/legacy/types/patients/patients'
import { UUID } from '@/libs/typing/base'

export enum SubtaskStatus {
  OPEN_UNASSIGNED = 'OPEN_UNASSIGNED',
  REATTEMPT = 'REATTEMPT',
  OPEN_ASSIGNED = 'OPEN_ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  CLOSED_IN_ERROR = 'CLOSED_IN_ERROR',
  BLOCKED = 'BLOCKED',
}

export type AutogeneratedNote = {
  description: string
  noteId: string
}

export type UpdateSubtaskParams = {
  dueDatetime?: string
  notes?: string | null
  responsibleRole?: null | EntityRole
  responsibleStaffId?: string | null
  showTime?: boolean
  status?: SubtaskStatus
  priority?: SubtaskPriority
  customSubject?: string | null
  pointerToCommId?: string | null
}

export type Subtask = {
  channel: string | null
  communicationMaps?: { communicationId: string }[]
  description: string | null
  dueDatetime: string
  hideDatetime: string | null
  estimatedMinutesToComplete: number | null
  hyperlinks: string[] | null
  legacyFormTemplateId: string | null
  minStartDatetime: string
  memberId: string | null
  notes: string | null
  pathwayIds: string[]
  patient?: Patient
  priority: SubtaskPriority
  responsibleRole: null | EntityRole
  responsibleStaffId: string | null
  showTime: boolean
  status: SubtaskStatus
  statusReason: StatusReason | null
  statusReasonJson: StatusReasonMetadata | null
  statusUpdatedAt: string
  customSubject: string | null
  subtaskId: string
  subtaskVariantId: string
  taskIds: string[]
  title: string
  autogeneratedNotes: AutogeneratedNote[]
  generatingTriggerId: UUID | null
  queueStyle: QueueStyle

  latestReattempt?: Reattempt | null

  existingResponseAnswers?: any
  formResponseId?: string
  formTemplateVersion?: any
  pastResponses?: any
  variantDisplay?: string
  disableDueDate: boolean
  disablePriority: boolean
  pointerToCommId?: string | null
  reattemptCadence?: Array<number> | null
} & Timestamps
